




































import { StringProp } from '@/util/prop-decorators';
import { ApolloQueryResult } from 'apollo-client';
import { Component, Vue } from 'vue-property-decorator';
import query from './view.gql';
import {
  AppCustomerEnerIqApiViewQuery,
  AppCustomerEnerIqApiViewQueryVariables,
} from './__generated__/AppCustomerEnerIqApiViewQuery';

@Component({
  apollo: {
    customers: {
      query,
      fetchPolicy: 'network-only',
      variables(this: EnerIqApiView): AppCustomerEnerIqApiViewQueryVariables {
        return { customerId: this.customerId };
      },
      result(this: EnerIqApiView, { data }: ApolloQueryResult<AppCustomerEnerIqApiViewQuery>): void {
        if (data.customers.first.enerIqApi === null) {
          this.$router.back();
        }
      },
    },
  },
  data() {
    return { customers: undefined };
  },
})
export default class EnerIqApiView extends Vue {
  @StringProp(true)
  private readonly customerId!: string;

  private readonly customers?: AppCustomerEnerIqApiViewQuery['customers'];
}
